<script setup>
import { onMounted, ref } from 'vue'
import { ClockIcon, ShoppingCartIcon } from '@heroicons/vue/24/outline'
import HammerIcon from '@/Components/Icons/SolidHammer.vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const countdown = ref('')

const updateCountdown = () => {
  const updateTime = () => {
    const time = moment(props.item.ends_at)
    if (time.isBefore(moment())) {
      countdown.value = 'Closed'
      return
    }
    const now = moment()
    const diff = moment.duration(time.diff(now))

    const days = diff.days()
    const hours = diff.hours()
    const minutes = diff.minutes()
    const seconds = diff.seconds()

    if (days > 0) {
      countdown.value = `${days}d ${hours}h`
    } else {
      countdown.value = `${hours}:${minutes}:${seconds}`
    }
  }

  updateTime()

  setInterval(updateTime, 1000)
}

onMounted(() => {
  updateCountdown()
})
</script>

<template>
  <div
    class="flex flex-col justify-center items-start col-span-1 overflow-hidden bg-white rounded-[3px] border border-[#ddd] h-full"
  >
    <a :href="route('auctions.show', item)">
      <img
        :src="item.image"
        :alt="item.title"
        class="aspect-1 object-cover"
        loading="lazy"
      />
    </a>
    <div class="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-2.5 p-2">
      <div class="line-clamp-2">
        <a
          :href="route('auctions.show', item)"
          class="flex-grow-0 flex-shrink-0 text-sm text-left text-[#1c87c3] visited:text-purple-800 hover:underline"
        >
          {{ item.title }}
        </a>
      </div>
    </div>
    <div class="flex justify-between items-center self-stretch flex-grow-0 flex-shrink-0 px-2 pb-2">
      <div class="w-fit max-w-32 sm:w-auto xl:max-w-40 break-words">
        <a :href="item.url_store" class="flex-grow-0 flex-shrink-0 text-xs text-left text-black hover:underline">
          {{ item.seller }}
        </a>
      </div>

      <p v-if="item.type === 'auction'" class="text-xs">{{ __(':count bids', { count: item.num_bids }) }}</p>
    </div>
    <div
      class="flex justify-between items-start self-stretch flex-grow-0 flex-shrink-0 p-2.5 border-t border-r-0 border-b-0 border-l-0 border-[#ddd]"
    >
      <div v-if="item.type === 'auction'" class="flex justify-between items-center w-full py-0.5">
        <!-- left -->
        <div>
          <a
            :href="route('auctions.show', item)"
            class="flex justify-center items-center flex-grow-0 flex-shrink-0 gap-[3px] px-1.5 py-[3px] rounded-sm bg-gray-100 border border-gray-200"
          >
            <div class="flex-grow-0 flex-shrink-0 text-xs text-left">
              {{ price(item.price, null, true) }}
            </div>
            <HammerIcon class="size-3.5" />
          </a>
        </div>

        <!-- right -->
        <div class="flex items-center text-xs"
             :class="countdown === 'Closed' ? 'text-red-500' : ''"
        >
          <ClockIcon class="hidden sm:block w-4 h-4" />
          <span>{{ countdown }}</span>
        </div>
      </div>

      <div v-else class=" flex justify-between items-center w-full py-0.5">
        <a
          :href="route('auctions.show', item)"
          class="flex items-center bg-[#18a505] text-white justify-center px-1.5 space-x-1.5 py-1"
        >
          <ShoppingCartIcon class="fill-white size-3.5" />
          <div class="flex-grow-0 flex-shrink-0 text-xs text-left">
            {{ price(item.price, null, true) }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
